import escape from 'lodash/escape';

export function generateGTMScript(hid, gtmId) {
  return {
    hid,
    innerHTML: `
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${escape(gtmId)}');
  `,
  };
}

export function generateGtagScript(hid, gtagId) {
  return [
    {
      src: `https://www.googletagmanager.com/gtag/js?id=${escape(gtagId)}`,
      async: true,
    },
    {
      hid,
      innerHTML: `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${escape(gtagId)}');
    `,
    },
  ];
}
